import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

const AnimatedPromoCard = () => {
  const [currentColor, setCurrentColor] = useState(0);
  const colors = [
    "linear-gradient(135deg, #6366f1, #8b5cf6)",
    "linear-gradient(135deg, #3b82f6, #6366f1)",
    "linear-gradient(135deg, #10b981, #3b82f6)",
    "linear-gradient(135deg, #f59e0b, #ef4444)",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColor((prev) => (prev + 1) % colors.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        background: colors[currentColor],
        borderRadius: "12px",
        padding: "24px",
        marginBottom: "32px",
        color: "white",
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
          zIndex: 1,
        }}
      />
      <div style={{ position: "relative", zIndex: 2 }}>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "700",
            marginBottom: "12px",
            textShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          Join our biggest platform yet
        </h2>
        <p
          style={{
            fontSize: "16px",
            marginBottom: "24px",
            opacity: 0.9,
            lineHeight: 1.5,
          }}
        >
          Join us and get 60Rs/0.02$ as a register reward
        </p>
        <p
          style={{
            fontSize: "16px",
            marginBottom: "24px",
            opacity: 0.9,
            lineHeight: 1.5,
          }}
        >
          Join the hustle! 1000+ users are already cashing in daily on this
          trusted platform. Don’t miss out — sign up now and start boosting your
          earnings like a pro!
        </p>
        <motion.a
          href="https://earn-tube.online/login?referralCode=7ecf7cbb" // Replace with your actual link
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(10px)",
            padding: "12px 24px",
            borderRadius: "8px",
            fontWeight: "600",
            textDecoration: "none",
            color: "white",
            border: "1px solid rgba(255,255,255,0.3)",
          }}
        >
          Join Now <FiArrowRight style={{ marginLeft: "8px" }} />
        </motion.a>
      </div>

      {/* Animated floating elements */}
      <motion.div
        animate={{
          y: [0, -10, 0],
          rotate: [0, 5, 0],
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{
          position: "absolute",
          top: "20%",
          right: "10%",
          fontSize: "48px",
          opacity: 0.2,
        }}
      >
        ✨
      </motion.div>
      <motion.div
        animate={{
          y: [0, 15, 0],
          rotate: [0, -5, 0],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.5,
        }}
        style={{
          position: "absolute",
          bottom: "15%",
          left: "10%",
          fontSize: "48px",
          opacity: 0.2,
        }}
      >
        💰
      </motion.div>
    </motion.div>
  );
};

export default AnimatedPromoCard;
